import React from 'react'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import FlagIcon from '@mui/icons-material/Flag'

import Skeleton from 'components/CarSettings/Common/Creation/Summary/Skeleton'
import TranslationItem from 'components/CarSettings/Common/Creation/Summary/TranslationItem'
import SummaryItem from 'components/Common/SummaryItem'

import { textFiles } from 'constants/textFiles'
import useTranslation from 'hooks/useTranslation'
import { CountryVersionCreationProps } from 'utils/CarSettings/CountryVersion/creation'

import { SectionContainer } from 'styles/creation'

const Summary = ({
  handleBack,
  handleSubmit,
  submitLoading,
  countryVersionData,
}: CountryVersionCreationProps) => {
  const { text: generalText } = useTranslation(textFiles.GENERAL)
  const { text } = useTranslation(textFiles.COUNTRY_VERSION_CREATION)
  const { summary } = text
  const { countryVersionInformation } = countryVersionData
  const { translations } = countryVersionInformation

  return (
    <Skeleton
      previousFunction={handleBack}
      nextFunction={handleSubmit}
      title={summary.title}
      description={summary.description}
      submitLoading={submitLoading}
    >
      <SectionContainer>
        <SummaryItem
          title={summary.country}
          text={countryVersionInformation.country}
          icon={<FlagIcon />}
        />
        <SummaryItem
          title={summary.status}
          text={generalText.status[countryVersionInformation.status]}
          icon={<CheckCircleIcon />}
        />
        {translations.length > 0 ? (
          <TranslationItem
            translations={countryVersionInformation.translations}
          />
        ) : null}
      </SectionContainer>
    </Skeleton>
  )
}

export default Summary
